import CartItem from './CartItem';
import { SERVICE_CATEGORIES } from '../../../adlevo-vue/appConfiguration';
import { getUserCurrency } from '../../../utils/siteSettings';
import { __loco } from '../../../utils/localization';
import moment from 'moment';
import { objectToUrlParams } from '../../../utils/urlParams';

// Decided to go with old flow
export default class ActivityCartItem extends CartItem {

	/**
	 * @param {Object} data - Tour Data For Cart
	 * @param {number} data.id - Tour id
	 * @param {string} data.name - Tour Title
	 * @param {Array} data.photos - Tour Image
	 * @param {String} data.date - Tour Image
	 * */
	constructor(data) {
		super(SERVICE_CATEGORIES.ACTIVITIES);
		const keys = Object.keys(data);
		keys.forEach(key => {
			this[key] = data[key];
		});
	}

	/** @override
	 * * @param {CartItem} cartItem
	 * * @return Boolean
	 */
	isMatched(cartItem) {
		return (
			cartItem.id === this.id &&
			cartItem.type === this.type
		);
	}

	/** @override
	 *	@param {ActivityCartItem} activityCartItem
	 *	@return null
	 */
	updateData(activityCartItem){
		const keys = Object.keys(activityCartItem);
		keys.forEach(key => {
			this[key] = activityCartItem[key];
		});
	}

	/** @override
	 *	@return string
	 */
	getTitle() {
		return this.name;
	}

	/** @override
	 *	@return string
	 */
	getImageUrl() {
		return this.photos && this.photos.length ? this.photos[0].path_url : null;
	}

	getTotal() {
		return parseFloat(this.basket.total_price).toFixed(2)
	}

	/** @override
	 *	@return HTMLElement
	 */
	getHtmlCard() {
		const currency = getUserCurrency();
		const element = document.createElement('div');

		const duration = this.duration_time_hour
			? `${this.duration_time_hour} hour${this.duration_time_min ? ` ${this.duration_time_min} minutes / ` : ' / '}`
			: ' ';
		const tourDate = moment(this.basket.date, 'YYYY-MM-DD').format('ddd, MMM DD');

		let startTime = moment(this.start_time, 'HH:mm:ss').format('HH:mm');
		/**
		 * check if an option was added to cart
		 */
		if (this.tour_option_id !== undefined && this.tour_option_time !== undefined) {
			startTime = moment(this.tour_option_time, 'HH:mm:ss').format('HH:mm');
		}

		/**
		 * Override startTime for all day tours
		 */
		if(this.is_all_day_tour) {
			startTime = __loco('Any hour');
		}

		element.className = 'cartItem';
		element.id = 'cart-item-' + this.type + 'this.id';

		const urlParams = objectToUrlParams({
			// adults: data.adults,
			// children: data.children,
			start_date: this.basket.date,
			basket: this.basket
		});

		element.innerHTML = `
				<div class="cartItemContainer light-theme">
					<div class="row">
						<div class="col-12">
							<h5 class="subtitle-2 font-weight-medium secondary-text">${this.getTitle()}</h5>
						</div>
					</div>
			<div class="row justify-content-between">
				<div class="col-6">
					<p class="cartTourData caption secondary-text">${duration}${this.basket.tickets_count}  ${__loco('tickets')}</p>
							<p class="cartTourData caption secondary-text">${tourDate}</p>
							<p class="cartTourData caption secondary-text">${startTime}</p>
							${this.basket.selected_tickets.map(ticket => `
								<p class="cartTourData caption secondary-text">${ticket.ticket.name}: ${ticket.tickets} X ${ticket.ticket.price}${this.currency_type ? this.currency_type :  getUserCurrency()}</p>`).join('')}
				</div>
				<div class="col-6">
					<div class="row justify-content-end">
					<img class="cartItemImage" alt="cart item image" src="${this.getImageUrl()}"></div>
				</div>
			</div>
					<div class="row align-items-center">
					<div class="col-6">
						<div class="row align-items-center">
							<div class="col-auto">
								<a class="cart__item_left-footer__button" href="${this.service_url}${urlParams}#check-availability-section">${__loco('Edit')}</a>
							</div>
							<div class="col-auto pl-0 pr-0">
								<span>|</span>
							</div>
							<div class="col-auto">
								<a class="cart__item_left-footer__button cart-item-remove-btn" data-type="${this.type}" data-id="${this.id}">${__loco('Remove')}</a>
							</div>
						</div>
					</div>
					<div class="col-6"><div class="row justify-content-end align-items-center">
						<div class="col-12">
							<p class="cart__item_price-wrapper body-2">${this.currency_type ? this.currency_type :  getUserCurrency()} <span class="cart__item_price subtitle-2">${this.getTotal()}</span></p>
						</div>
					</div></div>
				</div>
				</div>
		`
		return element;
	}

	toRequestPayloadForValidateItems() {
		return {
			[this.id]: {
				...this,
				tour_id: this.id,
			},
		};
	}

	/** @override Get CartItem Type
	 *	@return string
	 */
	getType() {
		return this.type;
	}

	/** @override Get CartItem Id
	 *	@return Number|String
	 */
	getId() {
		return Number(this.id);
	}
}